import groupBy from 'lodash/groupBy';
import map from 'lodash/map';
import {
  BookingCategory,
  LicensePlateInfo,
  SelectedSalesItemsCar,
  SelectedSalesItemsCarGrouped,
  SelectedSalesItemsForCar
} from 'noddi-types';

export const groupCars = (items: SelectedSalesItemsCar[]): SelectedSalesItemsCarGrouped[] => {
  // Create composite key for grouping
  const grouped = groupBy(items, (item) => `${item.licensePlate.number}_${item.licensePlate.countryCode}`);

  return map(grouped, (group) => ({
    licensePlate: {
      number: group[0]!.licensePlate.number,
      countryCode: group[0]!.licensePlate.countryCode
    },
    selectedSalesItemIds: group.map((item) => item.salesItemId)
  }));
};

export const groupCarsWithQuantity = (items: SelectedSalesItemsCar[]): SelectedSalesItemsForCar[] => {
  // Create composite key for grouping
  const grouped = groupBy(items, (item) => `${item.licensePlate.number}_${item.licensePlate.countryCode}`);

  return map(grouped, (group) => ({
    licensePlate: {
      number: group[0]!.licensePlate.number,
      countryCode: group[0]!.licensePlate.countryCode
    },
    salesItems: group.map((item) => ({
      salesItemId: item.salesItemId,
      quantity: 1
    }))
  }));
};

export const compareLicensePlates = (licensePlate1: LicensePlateInfo, licensePlate2: LicensePlateInfo) =>
  licensePlate1.number === licensePlate2.number && licensePlate1.countryCode === licensePlate2.countryCode;

export const getSalesItemCarsPayload = (selectedSalesItemsCars: SelectedSalesItemsCar[]) =>
  groupCars(selectedSalesItemsCars).map((car) => ({
    licensePlate: car.licensePlate,
    selectedSalesItemIds: car.selectedSalesItemIds,
    pickupAddressId: selectedSalesItemsCars.find(
      (item) =>
        compareLicensePlates(item.licensePlate, car.licensePlate) && item.metaData?.selectedTireHotelPickUpAddress
    )?.metaData?.selectedTireHotelPickUpAddress?.id
  }));

export const bookingCategoryLabelToEnum = (serviceFromApi: BookingCategory | string): BOOKING_CATEGORY_ENUM => {
  switch (serviceFromApi) {
    case BookingCategory.WHEEL_SERVICES:
      return BOOKING_CATEGORY_ENUM.WHEEL_SERVICES;
    case BookingCategory.WASH_SERVICES:
      return BOOKING_CATEGORY_ENUM.WASHING_SERVICES;
    case BookingCategory.STONE_CHIP_REPAIR:
      return BOOKING_CATEGORY_ENUM.STONE_CHIP_REPAIR;
    default:
      return BOOKING_CATEGORY_ENUM.WHEEL_SERVICES;
  }
};

export enum BOOKING_CATEGORY_ENUM {
  WHEEL_SERVICES,
  WASHING_SERVICES,
  STONE_CHIP_REPAIR
}
